import { userManager } from './user.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const accessTokenInterceptor = (request) => {
  if (typeof window === "undefined")
    return;
  const accessToken = userManager.getAccessToken();
  if (accessToken) {
    request.headers.set("Authorization", `Bearer ${accessToken}`);
  } else {
    const user = userManager.loadUser();
    if (user == null ? void 0 : user.accessToken) {
      window.track("customEvent", "accessTokenExpired", {
        action: "accessTokenExpired",
        category: "customer",
        label: JSON.stringify(__spreadProps(__spreadValues({}, user), { accessToken: void 0 })),
        property: "tekoid-js"
      });
    }
  }
};
const getAccessToken = () => userManager.getAccessToken();

export { accessTokenInterceptor, getAccessToken };
